import React, { useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

const BarcodeScanner = ({ onResult, onClose }) => {
    useEffect(() => {
        // We use a small delay to ensure the DOM node is fully mounted before Html5QrcodeScanner initializes
        let scanner = null;
        
        const initScanner = setTimeout(() => {
            scanner = new Html5QrcodeScanner(
                "barcode-reader",
                { 
                    fps: 10, 
                    qrbox: { width: 250, height: 250 },
                    aspectRatio: 1.0,
                    showTorchButtonIfSupported: true,
                    rememberLastUsedCamera: true
                },
                false
            );

            scanner.render(
                (decodedText) => {
                    // Success callback
                    scanner.clear();
                    onResult(decodedText);
                },
                (error) => {
                    // Constant scan loop errors – safe to ignore normally
                }
            );
        }, 100);

        return () => {
            clearTimeout(initScanner);
            if (scanner) {
                scanner.clear().catch(error => console.error("Failed to clear scanner", error));
            }
        };
    }, [onResult]);

    return (
        <div className="relative bg-white flex flex-col items-center w-full">
            <style>
                {`
                    #barcode-reader { width: 100%; border: none !important; }
                    #barcode-reader__dashboard_section_csr button {
                        padding: 10px 20px;
                        background-color: #232F3E;
                        color: white;
                        border-radius: 12px;
                        font-weight: 900;
                        text-transform: uppercase;
                        margin: 10px 0;
                        border: none;
                        cursor: pointer;
                    }
                    #barcode-reader__dashboard_section_csr select {
                        padding: 10px;
                        border-radius: 8px;
                        border: 1px solid #ccc;
                        margin-bottom: 10px;
                        width: 100%;
                    }
                `}
            </style>
            <div id="barcode-reader" className="w-full max-w-[350px]"></div>
            <button 
                onClick={onClose}
                className="mt-6 bg-red-50 text-red-500 hover:bg-red-500 hover:text-white font-black text-[10px] tracking-widest uppercase py-4 px-8 rounded-2xl transition-colors w-full"
                type="button"
            >
                Fèmen Scanner
            </button>
        </div>
    );
};

export default BarcodeScanner;
